<template>
  <transition name="modal">
    <div
      v-if="showModal"
      class="modal block"
      :class="getCssClasses"
      tabindex="-1"
      aria-modal="true"
      role="dialog"
      :style="{ height: '100vh' }"
      @click="modalStore.closeModal"
    >
      <div
        class="modal-dialog modal-dialog-centered pb-0 md:pb-7 pt-7 mx-auto my-0 md:items-center items-end"
        :class="modalSize"
      >
        <div
          class="modal-content shadow overflow-hidden"
          @click.stop
        >
          <!-- modal header -->
          <div class="p-4 lg:pb-5 lg:px-6 bg-warning">
            <div class="form-row items-center">
              <!-- title -->
              <div class="col">
                <strong class="h3 m-0">{{ modalTitle }}</strong>
              </div>
              <!-- close button -->
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-primary p-2 rounded-circle"
                  aria-label="Close"
                  @click="modalStore.closeModal"
                >
                  <i class="mi-times icon-16" />
                </button>
              </div>
            </div>
          </div>
          <!-- modal wave -->
          <Wave
            path="waveFive"
            :color="waveColor"
            :x-center="false"
            class="relative hidden lg:block"
          />
          <!-- modal content -->
          <div :class="`p-4 lg:p-6 ${backgroundColor}`">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>

  <transition name="backdrop">
    <div
      v-if="showModal"
      class="modal-backdrop"
    />
  </transition>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import Wave from '@/components/general/BaseWave.vue'
import { useModalStore } from '@/stores/ModalStore'

const route = useRoute()

const props = defineProps({
  title: {
    type: String,
    default: '',
  },

  modalId: {
    type: String,
    default: () => `modal-id-${Math.random().toString(36).slice(7)}`,
  },

  xl: {
    type: Boolean,
    required: false,
    default: false,
  },

  backgroundColor: {
    type: String,
    default: '',
  },

  waveColor: {
    type: String,
    default: 'text-primary-200',
  },
})

const modalStore = useModalStore()
const { getId, getCssClasses, getTitle } = storeToRefs(modalStore)

const showModal = computed(() => getId.value === props.modalId)

const modalTitle = computed(() => props.title || getTitle.value)

const modalSize = props.xl ? 'modal-xl' : 'modal-lg'

watch(
  () => route.fullPath,
  () => {
    modalStore.closeModal()
  }
)
</script>
